module.exports = __webpack_public_path__ + "static/media/student_view_edit_student_schedule_video.4f1aafaa.mov";